import { get, normalizeUri, splitTags } from '../../../utils/utils';
import { getWixThumbnailsUrls, getWixVideoPreviewUrls } from '@wix/thumbnail-generator';
import { toObject } from '../../../utils/mappers';
import { MediaType } from '../../../constants/MediaType';
export function toItem(itemData, settings, thumbnailSizes, isSiteOwner) {
  let item = {
    id: itemData.file_name,
    folderId: itemData.parent_folder_id || null,
    fileSize: itemData.file_size,
    name: itemData.original_file_name,
    mediaType: itemData.media_type,
    fileUrl: itemData.file_url ? normalizeUri(itemData.file_url) : null,
    sourceUrl: itemData.source_url || null,
    createdAt: itemData.created_ts,
    updatedAt: itemData.modified_ts,
    readOnly: itemData.read_only || null,
    isSiteOwner,
    labels: itemData.labels || [],
    tags: splitTags(itemData.tags),
    width: itemData.width || null,
    height: itemData.height || null,
    fileInfo: itemData.file_info ? toObject(itemData.file_info) : null,
    fileInput: itemData.file_input ? toObject(itemData.file_input) : null,
    fileOutput: itemData.file_output ? toObject(itemData.file_output) : null,
    transcodingStatus: itemData.op_status
  };
  if (item.mediaType === MediaType.Video) {
    item.width = get(item, 'fileOutput.image[0].width', itemData.width);
    item.height = get(item, 'fileOutput.image[0].height', itemData.height);
  }
  const sizes = {
    ...settings.thumbnailSizes,
    ...thumbnailSizes
  };
  item = {
    ...item,
    ...getWixThumbnailsUrls(item, sizes, settings)
  };
  if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
    item.thumbnailUrl = normalizeUri(settings.filesUrl + "/" + itemData.icon_url);
  }
  Object.keys(sizes).forEach(function (thumbType) {
    if (!item[thumbType + "Url"]) {
      item[thumbType + "Url"] = item.thumbnailUrl;
    }
  });
  Object.keys(item).forEach(function (prop) {
    if (item[prop] === undefined) {
      delete item[prop];
    }
  });
  item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings) || null;
  return item;
}